import { definePreset } from '@primeuix/themes'
import Lara from '@primeuix/themes/lara'
import { eneeComponents } from './enee.components'
import { eneePrimitive } from './enee.primitive'
import { eneeSemantic } from './enee.semantic'

const enee = definePreset(Lara, {
  primitive: eneePrimitive,
  semantic: eneeSemantic,
  components: eneeComponents,
})

export default enee
